import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import NavigationProvider from 'studio5/components/Navigation/NavigationProvider';
import SettingsNavigationProvider from 'studio5/components/SettingsNavigation/SettingsNavigationProvider';

const Wrapper = styled.div`
  display: flex;
  min-height: inherit;
`;

const NavWrapper = styled.div`
  flex-basis: 240px;
  flex-grow: 0;
  flex-shrink: 0;
`;

const Content = styled.div`
  flex-grow: 1;
  position: relative;
  flex-direction: column;
  min-width: 0;
  display: flex;
`;

const SETTINGS_PREFIXES = [
  '/settings',
  '/integrations',
  '/webhooks',
  '/apps/',
  '/themes',
];

const NO_NAV_PATHS = new Set([
  '/accounts',
  '/accounts-v2',
  '/logout',
  '/signup_info',
  '/usage',
  '/welcome',
  '/invite-team-members',
  '/email-sender/verify',
]);

const NO_NAV_PREFIXES = ['/dashboards'];

function useNavigation() {
  const { pathname } = useLocation();

  if (
    NO_NAV_PATHS.has(pathname) ||
    NO_NAV_PREFIXES.some(p => pathname === p || pathname.startsWith(`${p}/`))
  ) {
    return null;
  }

  if (SETTINGS_PREFIXES.some(prefix => pathname.startsWith(prefix))) {
    return <SettingsNavigationProvider />;
  }

  return <NavigationProvider />;
}

type ShellLayoutProps = {
  children: ReactNode;
};

export const ShellLayout = ({ children }: ShellLayoutProps) => {
  const navigation = useNavigation();

  return (
    <Wrapper>
      {navigation && <NavWrapper id="navigation">{navigation}</NavWrapper>}
      <Content id="main">{children}</Content>
    </Wrapper>
  );
};
